module.exports = __webpack_public_path__ + "static/slidecard01_02-336c1893bd74b254ad3b15a5c90d61be.png";